// export default Seatreservation;

import React, { useEffect, useState } from "react";
import "./Seatreservation.css";
import AirplaneBody from "../../components/airplane/AirplaneBody";
import ChooseSeatsConformationCard from "../../components/ChooseSeatsConformationCard/ChooseSeatsConformationCard";
import { useNavigate, useParams } from "react-router-dom";
import FetchData from "../../components/Api/FetchData";
import Loader from "../../components/common/Loader";

const Seatreservation = () => {
  const { CategorieId } = useParams();

  const [flight, setFlight] = useState({});
  const [labels, setLabels] = useState({
    A: [],
    B: [],
    C: [],
    D: [],
    E: [],
    F: [],
  });

  const [load, setLoad] = useState(false);
  const [titleDescription, setTitleDescription] = useState("");
  const [allSeatsSelected, setAllSeatsSelected] = useState([]);

  const navigate = useNavigate();

  function compareByRow(a, b) {
    return a.row - b.row;
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    let description = localStorage.getItem("description");
    setTitleDescription(JSON.parse(description));

    let flight = localStorage.getItem("flight");
    flight = JSON.parse(flight);

    if (flight) {
      setLoad(true);

      FetchData(
        `/flights?flight_no=${flight.flight_no}&departure_date=${flight.departure_date}`
      )
        .then((data) => {
          if (data.status === 200) {
            localStorage.setItem("flight", JSON.stringify(data.data));

            setFlight(data.data);

            let seats = data.data.seats;
            let object = {};

            Object.keys(labels).forEach((label) => {
              let seatsFilter = seats
                .filter(
                  (seat) => seat.column.toUpperCase() === label
                )
                .sort(compareByRow);

              object = {
                ...object,
                [label]: seatsFilter,
              };
            });

            setLabels(object);
            setLoad(false);
          }
        })
        .catch(() => {
          setLoad(false);
        });
    }
  }, []);

  const handleSelectSeat = (seats) => {
    setAllSeatsSelected(seats);
  };

  if (load) {
    return <Loader />;
  }

  return (
    <div className="container">
      <div className="row">
        <h3
          className="mt-4 fw-bold"
          style={{ color: "#273771" }}
        >
          Seat reservation
        </h3>
      </div>

      <div className="container text-start mt-4">
        <div className="seat-legend-row">
          <div
            dangerouslySetInnerHTML={{
              __html: titleDescription,
            }}
            style={{
              color: "#292929",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            className="text seat-legend-description"
          />

          <section className="seat-legend-card" aria-label="Seat guide">

            <div className="seat-legend-grid">
              <h4 className="seat-legend-title">Seat guide</h4>

              <div className="seat-legend-item"><span className="seat-legend-exit"><span>&#8592;</span><i /><span>&#8594;</span></span><span>Emergency exit</span></div>

              <div className="seat-legend-item"><span className="seat-legend-icon seat-legend-selected" /><span>Selected</span></div>
              <div className="seat-legend-item"><span className="seat-legend-icon seat-legend-available" /><span>Available</span></div>
              <div className="seat-legend-item"><span className="seat-legend-icon seat-legend-taken" /><span>Taken</span></div>
              <div className="seat-legend-item"><span className="seat-legend-icon seat-legend-xl" /><span>XL seat</span></div>
              <div className="seat-legend-item"><span className="seat-legend-icon seat-legend-unavailable" /><span>Not available</span></div>
              <div className="seat-legend-item"><span className="seat-legend-icon seat-legend-business" /><span>Business class</span></div>
              <div className="seat-legend-item"><span className="seat-legend-symbol seat-legend-galley">G</span><span>Galley</span></div>
              <div className="seat-legend-item"><span className="seat-legend-symbol seat-legend-lavatory">L</span><span>Lavatory</span></div>
            </div>
          </section>
        </div>

        <div
          className="d-flex flex-wrap justify-content-between gap-4 p-3 mt-3"
          style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
          }}
        >
          <div className="d-flex flex-column gap-2">
            <span style={{ color: "#091007", fontWeight: "800", fontSize: "13px", fontStyle: "italic" }}>
              business seats
            </span>
            <div className="d-flex flex-column gap-1">
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#ffffff", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>Priority boarding</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#fefffe", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>Extra legroom</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#ffffff", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>Free In-Seat Power</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#fefffe  ", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>New Gen 2 seat design</span>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column gap-2">
            <span style={{ color: "#292929", fontWeight: "800", fontSize: "13px", fontStyle: "italic" }}>
              Standard
            </span>
            <div className="d-flex gap-3 flex-wrap align-items-center">
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#ffffff", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>Everyday low fares</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#fefffe  ", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>New Gen 2 seat design</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <span style={{ color: "#ffffff", backgroundColor: "#0e0f0e", padding: "0px 2px ", borderRadius: "50%", fontSize: "12px" }}>&#10003;</span>
                <span style={{ fontSize: "12px" }}>In-Seat Power</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row">
            <div className="col-12 col-xl-11">
              <AirplaneBody
                flight={flight}
                labels={labels}
                selectedSeat={allSeatsSelected}
                onSelectSeat={handleSelectSeat}
              />
            </div>

            <div className="col-12 col-xl-1">
              <div className="mb-5">
                <ChooseSeatsConformationCard
                  allSeatsSelected={allSeatsSelected}
                  onSelectSeat={handleSelectSeat}
                  flight={flight}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function prepareSeatRows() {
  const availableSeatImg = `${process.env.PUBLIC_URL}/assets/blue2.png`;
  const takenSeatImg = `${process.env.PUBLIC_URL}/assets/parbel12.png`;

  const rows = [...Array(30)].map((_, rowIndex) => {
    const left = [...Array(4)].map((_, index) =>
      createSeatData(
        rowIndex,
        index,
        availableSeatImg,
        takenSeatImg
      )
    );

    const right = [...Array(4)].map((_, index) =>
      createSeatData(
        rowIndex,
        index + 6,
        availableSeatImg,
        takenSeatImg,
        index === 2
      )
    );

    return {
      left,
      right,
    };
  });

  return rows;
}

function createSeatData(
  rowIndex,
  seatIndex,
  availableSeatImg,
  takenSeatImg,
  skip = false
) {
  const isOccupied = Math.random() < 0.5;

  const seatLetter = String.fromCharCode(
    65 + seatIndex + (skip ? 1 : 0)
  );

  const seatNumber = `${rowIndex + 1}${seatLetter}`;

  const seatImage = isOccupied
    ? takenSeatImg
    : availableSeatImg;

  return {
    number: seatNumber,
    isOccupied,
    image: seatImage,
  };
}

export default Seatreservation;

